var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"xt-ck-content ck-blurred ck ck-content ck-editor__editable ck-rounded-corners ck-editor__editable_inline",domProps:{"innerHTML":_vm._s(_vm.formatFace(_vm.content))}})
}
var staticRenderFns = []

export { render, staticRenderFns }